mod.modules.define("BaseSection", function(fn) {

	fn.prototype.init = function(params) {
		mod.observer.trigger("section - loaded", this.el);
	};

});